<template>
	<page style="background: #fff">
		<c-detail>
			<c-detail-item label="服务类型">{{orderInfo.service_type == 2 ? '售后' : '售前'}}</c-detail-item>
			<c-detail-item label="工单负责人">{{orderInfo.charge_user_realname}}</c-detail-item>
			<c-detail-item label="工单参与人">{{orderInfo.group_user_realname ? orderInfo.group_user_realname.replaceAll(',', '、') : ''}}</c-detail-item>
			<c-detail-item label="完结时间">{{orderInfo.process_end_date}}</c-detail-item>
		</c-detail>

		<cut-line></cut-line>

		<dl class="appraise">
			<dt class="flex-start-center">
				<label>服务评分</label>
				<ul class="flex">
					<li v-for="(item, i) in stars" :key="i" :style="{'color': score <= i ? '#ddd' : '#FF6900'}" @click="score = i + 1">
						<i class="tf">&#xe71e;</i>
					</li>
				</ul>
				<span v-if="score">{{score}}分</span>
			</dt>
			<dd>
				<ul class="flex-wrap">
					<li v-for="(item, i) in tags" :key="i" :class="{'z-crt': item.current}" @click="$set(item, 'current', !item.current)">{{item.name}}</li>
				</ul>
			</dd>
		</dl>

		<cut-line></cut-line>

		<div class="comment flex-column flex-center">
			<div v-if="!images.length" class="upload flex-center" @click="uploadHandle"><i class="tf">&#xe71a;</i></div>
			<c-upload-file v-else v-model="images" type="image" media multiple="9" :side="false"></c-upload-file>
			<textarea v-model="remark" ref="input" placeholder="展开说说对服务的想法吧..."></textarea>
		</div>

		<template #button>
			<c-button size="form" color="main" @click="submitHandle">发布</c-button>
		</template>
	</page>
</template>

<script>
	export default {
		props: {
			id: String
		},

		data() {
			return {
				orderInfo: {},
				stars: new Array(5).fill(''),
				score: 0,
				tags: [{
					name: '服务专业'
				}, {
					name: '操作规范'
				}, {
					name: '服务态度好'
				}],
				images: [],
				remark: ''
			}
		},

		watch: {
			remark() {
				this.$nextTick(() => {
					this.$refs.input.style.height = 'auto';
					this.$refs.input.style.height = this.$refs.input.scrollHeight + 'px';	
				});
			}
		},

		mounted() {
			this.request({
				url: '/after/sale/order/detail',
				data: {
					id: this.id
				},
				success: ({detailInfo}) => {
					this.orderInfo = detailInfo;
				}
			})
		},

		methods: {
			uploadHandle() {
				this.$upload({
					type: 'image',
					multiple: true,
					success: data => {
						this.images = this.images.concat(data.map(item => item.path)).splice(0, 4);
					}
				});
			},

			submitHandle() {
				if (!this.score) {
					this.$message({
						message: '请选择评分'
					});
					return;
				}

				this.request({
					url: '/after/sale/order/evaluation',
					data: {
						order_id: this.id,
						service_score: this.score,
						evaluation_tags: this.tags.filter(item => item.current).map(item => item.name).join(','),
						evaluation_images: this.images.join(','),
						evaluation_content: this.remark
					},
					loading: true,
					success: () => {
						this.$message({
							message: '发布成功',
							mask: true
						});
						setTimeout(() => {
							this.mp.navigateBack();
						}, 1000);
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	>>> .c-detail {
		padding: .2rem .46rem;
		background: #fff;

		&-content {
			border: none;
		}

		&-item {
			border: none;
			padding: .06rem 0;

			&-label {
				width: auto;
				min-width: auto;
				border: none;
				padding: 0;
				font-size: .26rem;
				color: #91A1B9;
				background: none;

				&:after {
					content: '：';
				}
			}

			&-content {
				display: flex;
				flex-wrap: wrap;
				gap: .1rem;
				padding: 0;
				font-size: .26rem;
			}
		}
	}

	.appraise {
		padding: .4rem .32rem .6rem;

		dt {
			gap: .32rem;
			padding: 0 .12rem;
			font-size: .32rem;

			label {
				font-weight: bold;
			}

			ul {
				gap: .2rem;
				
				li {
					font-size: .44rem;
				}
			}

			span {
				color: #FF6900;
			}
		}

		dd {
			margin-top: .4rem;

			ul {
				gap: .14rem;

				li {
					border: .01rem dashed #333;
					border-radius: .28rem;
					padding: 0 .28rem;
					line-height: .54rem;
					font-size: .26rem;
					color: #333;

					&.z-crt {
						border-color: var(--color-main);
						color: var(--color-main);
						background: #F0F9FE;
					}
				}
			}
		}
	}

	.comment {
		gap: .42rem;
		padding: .4rem;

		.upload {
			width: 1.4rem;
			height: 1.4rem;
			border-radius: 50%;
			font-size: .76rem;
			color: #666;
			background: #F5F5F5;
		}

		>>> .c-upload {
			width: 100%;

			&-media {
				margin: 0;
			}

			&-tip {
				display: none;
			}
		}

		textarea {
			width: 100%;
			min-height: 2rem;
			line-height: .4rem;
			font-size: .3rem;
		}
	}
</style>